import gql from 'graphql-tag';

export const removeChallengeMutation = gql`
	mutation RemoveChallenge($id: ID!) {
		removeChallenge(id: $id) {
			id
		}
	}
`;
